import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [
  // View Menu
  nativeCommsMessageTypes.SHOW_NARRATIVE,
  nativeCommsMessageTypes.SHOW_OUTLINE,

  // Sync Menu
  nativeCommsMessageTypes.TOGGLE_SYNC_BINDER,
  nativeCommsMessageTypes.OPEN_SYNC_SETTINGS,
  nativeCommsMessageTypes.EXECUTE_SYNC
];
